// Utility for managing recent searches in localStorage

const RECENT_SEARCHES_KEY = 'briefed-recent-searches';
const MAX_RECENT_SEARCHES = 10;

export const saveRecentSearch = (searchQuery, filters) => {
  try {
    const existing = getRecentSearches();

    // Create search object
    const searchObj = {
      id: Date.now().toString(),
      searchQuery: searchQuery || '',
      filters: { ...filters },
      timestamp: new Date().toISOString()
    };

    // Remove duplicates (same query and key filters)
    const filtered = existing.filter(
      (search) =>
        !(
          search.searchQuery === searchObj.searchQuery &&
          search.filters.similarTo === searchObj.filters.similarTo &&
          search.filters.courthouse === searchObj.filters.courthouse &&
          search.filters.jurisdiction === searchObj.filters.jurisdiction
        )
    );

    // Add new search to beginning
    const updated = [searchObj, ...filtered].slice(0, MAX_RECENT_SEARCHES);

    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updated));
    return updated;
  } catch (error) {
    console.error('Error saving recent search:', error);
    return [];
  }
};

export const getRecentSearches = () => {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error loading recent searches:', error);
    return [];
  }
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch (error) {
    console.error('Error clearing recent searches:', error);
  }
};

export const formatSearchLabel = (searchQuery, filters) => {
  const parts = [];

  if (searchQuery) {
    parts.push(`"${searchQuery}"`);
  }

  if (filters.similarTo) {
    parts.push(`Similar closed cases to ${filters.similarTo}`);
  }

  if (filters.courthouse) {
    parts.push(`Court: ${filters.courthouse}`);
  }

  if (filters.judges?.length > 0) {
    parts.push(`Judge: ${filters.judges[0].lastName}`);
  }

  if (filters.charges?.length > 0) {
    parts.push(`Charge: ${filters.charges[0].code}`);
  }

  return parts.length > 0 ? parts.join(' • ') : 'All cases';
};
